import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import {
  delSinglebank,
  fetchBanks,
  updateBankStatus,
} from "../../../services/Inventory/inventory"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import InventoryFilter from "../filter"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import EditBanks from "./edit"
import { capitalize } from "lodash"
import { toTitleCase } from "../../../utils/toTitleCase"
import LogoutPopup from "../../../components/VerticalLayout/logoutpopup"
import { useLocation } from "react-router-dom"

const BanksSearch = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Banks${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [page, setPage] = useState("")
  const [search, setSearch] = useState("")
  const [status, setStatus] = useState("")
  const [series, setSeries] = useState("")
  const [classId, setClassId] = useState("")
  const [category, setCategory] = useState()
  const [count, setCount] = useState(0)
  const [editCategory, setEditCategory] = useState({ modal: false, value: "" })
  const [logoutModal, setLogoutModal] = useState(false)
  const [deleteId, setDeleteId] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchBanks({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${page ? `&page=${page}` : ""}${series ? `&series_id=${series}` : ""}${classId ? `&class_id=${classId}` : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setCategory(response)
      const newData = response?.data?.data || [];

      setCategory(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
  }, [count, status, search, page, series, classId, dataPerPage])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < category?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [category, page]);

  const handleEdit = item => {
    setEditCategory({ value: item, modal: true })
  }

  const handilRest = () => {
    setCount(count + 1)
  }
  const handleStatus = async id => {
    try {
      const response = await updateBankStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }
  const handleDelete = async id => {
    try {
      const response = await delSinglebank(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const columns = [
    {
      label: "Bank Name",
      renderCell: item => (
        <div>
          <div id={`PopoverLegacyhaha-${item?.id}`}>
            {item?.name?.length > 20
              ? `${toTitleCase(item.name.slice(0, 20))}...`
              : toTitleCase(item?.name) || "-"}
          </div>
          {item?.name?.length > 20 && (
            <UncontrolledPopover
              trigger="hover"
              placement="bottom"
              target={`PopoverLegacyhaha-${item?.id}`}
            >
              <PopoverBody>{toTitleCase(item?.name) || "-"}</PopoverBody>
            </UncontrolledPopover>
          )}
        </div>
      ),
    },
    {
      label: "IBAN Code",
      renderCell: item => (item?.iban_code ? capitalize(item?.iban_code) : "-"),
    },
    {
      label: "Swift Code",
      renderCell: item =>
        item?.swift_code ? capitalize(item?.swift_code) : "-",
    },
    {
      label: "State",
      renderCell: item => (item?.state ? item?.state?.name : "-"),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 &&
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "banks_edit"
                ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              <div
                className={`table-popup-content`}
                onClick={e => {
                  e.preventDefault()
                  setLogoutModal(true)
                  setDeleteId(item?.id)
                }}
              >
                Delete
              </div>
              <div
                className={`${item?.status === 1 ? "" : ""
                  } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditCategory("")
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSeriesChange = id => {
    setSeries(id)
    setPage(1)
  }
  const handleClassChange = id => {
    setClassId(id)
    setPage(1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Settings"
              breadcrumbObject={[
                { title: "Settings", link: "/settings" },
                { title: crumb || "Masters", link: "/settings" },
                { title: "Banks", link: "/settings-banks" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "banks_create"
            ) && (
                <EditBanks
                  key={"x"}
                  onUpdate={handleUpdate}
                  onReset={handleResetValue}
                  buttonLabel="+&nbsp; Bank"
                  className="px-2 mb-3 me-2 btn btn-primary"
                  editItem={editCategory}
                />
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleSeriesChange={handleSeriesChange}
              handleClassChange={handleClassChange}
              sampleUrl={"download/category.xlsx"}
              importUrl={"category/import"}
              showExport={false}
            // showExport={
            //   loggedUser?.permission?.some(
            //     permissionItem => permissionItem?.name === "banks_create"
            //   )
            //     ? true
            //     : false
            // }
            //   isSeries={true}
            //   isClass={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                {category?.data?.data && (
                  <UpdateTable
                    className="mt-5"
                    nodes={category?.data?.data}
                    paginate={category?.data}
                    CurrentPage={page}
                    columns={columns}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="20% 20% 20% 20% 10% 10%"
                    mobileWidth="40% 40% 40% 40% 20% 20%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <LogoutPopup
        isOpen={logoutModal}
        toggle={() => setLogoutModal(!logoutModal)}
        bankdelete={true}
        deleteId={deleteId}
        handilRest={handilRest}
      />
    </React.Fragment>
  )
}

export default BanksSearch
